import api from './config';

/**
 * Set the user's favorite streaming service.
 * Backend: PUT /external-service-access/favorite-service { serviceName }.
 * `serviceName` is the backend id (e.g. 'spotify', 'deezer', 'apple_music',
 * 'soundcloud', 'youtube_music').
 */
export const updateFavoriteService = async (serviceName: string) => {
  // Backend validates the kebab-case form (apple-music, youtube-music), then
  // normalizes to snake for the DB lookup — so send kebab.
  const kebab = serviceName.replace(/_/g, '-');
  const response = await api.put('/external-service-access/favorite-service', {
    serviceName: kebab,
  });
  return response.data;
};

/** Track that a recommendation card was opened (analytics). Best-effort. */
/** Track that a recommendation card became visible on the feed. Best-effort. */
export const trackRecommendationViewing = async (recommendationId: number) => {
  try {
    await api.post('/user-track-viewing/create', { recommendationId });
  } catch {
    // non-critical — analytics
  }
};

export const trackTrackOpening = async (recommendationId: number, serviceId: string) => {
  try {
    // Backend validates kebab-case service names (apple-music, youtube-music).
    const externalServiceName = serviceId.replace(/_/g, '-');
    await api.post('/user-track-opening/create', { recommendationId, externalServiceName });
  } catch {
    // non-critical — analytics
  }
};
